module.exports = __webpack_public_path__ + "img/new3-2.0325860a.jpg";